import AppContext from "@/AppContext";
import Layout from "@/components/elements/Layout";
import UserPreferenceTopicRegister from "@/components/profile/UserPreferenceTopicRegister";
import Spinner from "@/components/Spinner";
import { Button } from "@/components/ui/button";
import useAuth from "@/hooks/auth";
import { useUserPreferences } from "@/hooks/user_preferences";
import { Notebook, User } from "@phosphor-icons/react";
import { useRouter } from "next/router";
import { useContext } from "react";
import toast from "react-hot-toast";

export default function UserPreferences() {
  const router = useRouter();
  const { user } = useAuth({ middleware: "auth" });
  const context = useContext(AppContext);
  const {
    preferences,
    toggleUserPreference,
    updatePreferences,
    isUpdating,
    selectAll,
  } = useUserPreferences();

  const goToNextStep = () => {
    router.push(
      `/register/content-preferences${
        router.query.redirect_to
          ? `?redirect_to=${router.query.redirect_to}`
          : ""
      }`
    );
  };

  const savePreferences = async (evt) => {
    evt.preventDefault();

    if (preferences.length === 0) {
      goToNextStep();
      return;
    }

    try {
      await updatePreferences();
      toast.success("User preferences updated!");
      goToNextStep();
    } catch (error) {
      toast.error("Couldn't save your topic preferences — please try again.");
    }
  };

  return (
    <div className='min-h-screen pb-8 bg-gradient-to-b from-white/10 to-background lg:pb-16'>
      <div className='max-w-2xl px-4 pt-6 mx-auto'>
        <div className='inline-flex border divide-x rounded-lg divide-white/10 bg-white/10 border-white/10'>
          <div className='flex items-center p-3 text-left gap-x-2'>
            <span className='inline-flex items-center justify-center w-8 h-8 rounded-sm'>
              <User className='text-lg' weight='bold' />
            </span>
            {/* <div className='flex flex-col'>
                <span className='text-[10px] font-medium leading-none text-transparent bg-clip-text bg-gradient-to-tr from-yellow-1 to-red-1'>
                  Step 1/3
                </span>
                <p className='mt-1.5 text-sm font-medium leading-none text-white'>
                  Profile Information
                </p>
              </div> */}
          </div>
          <div className='flex items-center p-3 text-left gap-x-2'>
            <span className='inline-flex items-center justify-center w-8 h-8 bg-white rounded-sm text-background'>
              <User className='text-lg' weight='bold' />
            </span>
            <div className='flex flex-col'>
              <span className='text-[10px] font-medium leading-none text-transparent bg-clip-text bg-gradient-to-tr from-yellow-1 to-red-1'>
                Step 2/3
              </span>
              <p className='mt-1.5 text-sm font-medium leading-none text-white'>
                Topic Preferences
              </p>
            </div>
          </div>
          <div className='flex items-center p-3 text-left gap-x-2'>
            <span className='inline-flex items-center justify-center w-8 h-8 rounded-sm'>
              <Notebook className='text-lg' weight='bold' />
            </span>
            {/* <div className='flex flex-col'>
              <span className='text-[10px] font-medium leading-none text-transparent bg-clip-text bg-gradient-to-tr from-yellow-1 to-red-1'>
                Step 3/3
              </span>
              <p className='mt-1.5 text-sm font-medium leading-none text-white'>
                Content Preferences
              </p>
            </div> */}
          </div>
        </div>

        <div className='mt-12 lg:mt-20'>
          <p className='mb-2 text-4xl font-bold leading-tight text-white font-display md:text-6xl'>
            Select Preferred Topics
          </p>
          <p className='mt-3 text-white text-opacity-80'>
            Pick topics that you&lsquo;d like to see often
          </p>
          <form onSubmit={savePreferences} className='gap-8 mt-8'>
            <div className='mb-4'>
              <Button
                type='button'
                variant='outline'
                size='sm'
                className='bg-white/5'
                onClick={() => selectAll(context.state.topic_list)}
              >
                Select All
              </Button>
            </div>
            <div className='grid grid-cols-1 gap-4 lg:grid-cols-3'>
              {context.state.topic_list.map((topic) => (
                <UserPreferenceTopicRegister
                  key={`pref-topic-${topic.uuid}`}
                  topic={topic.name}
                  thumbnail={topic.image_url}
                  onChange={() => toggleUserPreference(topic.uuid)}
                  uuid={topic.uuid}
                  selected={preferences.includes(topic.uuid)}
                />
              ))}
            </div>
            <div className='mt-8'>
              <Button
                type='submit'
                size='lg'
                className='text-base text-white bg-gradient-to-tr from-yellow-1 to-red-1'
              >
                {isUpdating && <Spinner />}
                {isUpdating ? "Updating..." : "Save Changes"}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
